import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { ModalBase } from '../modal-base.component';
import { ModalData } from '../../models';
import { Router } from '@angular/router';

@Component({
  selector: 'message-modal',
  templateUrl: './message-modal.component.html',
  styleUrls: [
    '../../../../../../assets/styles/components/modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MessageModalComponent extends ModalBase {

  constructor(protected dialogRef: MatDialogRef<MessageModalComponent>,
              private router: Router,
              @Inject(MAT_DIALOG_DATA) public data: string | { message: string, title: string } | ModalData) {
    super(data);
  }

  ok(): void {
    this.dialogRef.close();
  }

  public isInfoModalData(): boolean {
    return this.data instanceof ModalData;
  }

  public hasLink(): boolean {
    return this.data instanceof ModalData && !!this.data.link;
  }

  public goToLink(link: string) {
    const routerLink = link.split('/');
    this.ok();
    this.router.navigate(routerLink);
  }

}
